import React from 'react';
import IosSync from "react-ionicons/lib/IosSync";
import "./styles.css";

export default function Loading(props) {
    return (<div className="Loading">
        <IosSync fontSize="90px" className={"animated rotating"}/>
    </div>);
};